module.exports = __webpack_public_path__ + "img/bijiu-no-data.d80d12d3.png";